// extracted by mini-css-extract-plugin
module.exports = {"button":"CollapsableSection_button__y3_2k"};